module.exports = "<div class=\"message-container\">\n  <div class=\"spinner-container\" *ngIf=\"loading\">\n    <mat-spinner class=\"loading-spinner\"></mat-spinner>\n  </div>\n\n  <div *ngIf=\"!loading\">\n    <span class=\"message\" >\n      <span *ngIf=\"!error\">You have successfully signed out.</span>\n      <span *ngIf=\"error\">An error occurred. Please try again.</span>\n      <div class=\"actions\">\n        <a mat-button [href]=\"['/home']\">\n          HOME\n        </a>\n      </div>\n    </span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth-sign-out.component.html
// module id = ./src/app/auth/auth-sign-out.component.html
// module chunks = main